var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-frame"},[_c('el-main',[_c('el-card',{attrs:{"shadow":"never"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon iconfont",class:_vm.menuIcon}),_c('span',[_vm._v(_vm._s(_vm.menuNmLan))])]),_c('div',{ref:"content",staticClass:"content"},[_vm._t("default")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }